export const CONNECTION_EVENTS = Object.freeze({
  CONNECT_UP: 'connect:up',
  CONNECT_DOWN: 'connect:down',
  RECONNECT_TICK: 'reconnect:tick',
  RECONNECT_STARTED: 'reconnect:started',
  RECONNECT_FAILURE: 'reconnect:failure',
  RECONNECT_SUCCESS: 'reconnect:success',
  RECONNECT_STOPPED: 'reconnect:stopped'
});

const DEFAULT_EVENT_OPTIONS = {
  cancelable: false,
  bubbles: false
};

export default {
  dispatchEvent(
    eventName: string,
    target: Element | Document = document,
    eventOptions: CustomEventInit = DEFAULT_EVENT_OPTIONS
  ) {
    const event = new CustomEvent(eventName, eventOptions);

    target.dispatchEvent(event);
  }
};
